module.exports = __webpack_public_path__ + "static/img/activity_sdy_02-4.5e9979e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_02-4.jpg
// module id = 3Y/Q
// module chunks = 0